<template>
    <!-- Hero Section -->
    <section class="hero__section__wrapper" :style="{ backgroundImage: `url(${heroBg})` }">
        <div class="rlms-container">
            <div class="cover__section">
                <h1 class="title">Early Echoic Skills Assessment</h1>

                <div class="tagline">
                    <div class="img__wrap">
                        <img :src="heroImg" alt="Hero" />
                    </div>
                    <h4 class="sub__title">and Program Planner App (EESAPP App)</h4>
                </div>

                <div class="hero__short__note">
                    <p>
                        The ESSAPP (Early Echoic Skills Assessment and Program Planner) is designed to support
                        professionals in assessing and developing echoic skills in learners. Now available as a web app.
                    </p>
                </div>

                <div class="hero__btn__group">
                    <div class="sign__up__btn">
                        <RouterLink :to="registerUrl">Sign Up Here</RouterLink>
                    </div>

                    <div class="watch__video__btn">
                        <a :href="socialWorkLink" target="_blank" rel="noopener" class="popup-youtube">
                            <span class="btn__icon">
                                <img :src="playCircleIcon" alt="Play Video" />
                            </span>
                            <span class="btn__text">Watch Video</span>
                        </a>
                    </div>

                    <div class="arrow__img">
                        <img :src="heroArrowImg" alt="Arrow" />
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Our Companiees -->
    <section class="our__companies__wrapper" :style="{ backgroundImage: `url(${ouCompaniesBg})` }">
        <div class="rlms-container">
            <div class="company__logos__wrap">
                <div v-for="(company, index) in companies" :key="index" class="logo__box">
                    <a :href="company.link" target="_blank" rel="noopener">
                        <img :src="company.img" :alt="`Logo ${index + 1}`" />
                    </a>
                </div>
            </div>
        </div>
    </section>

    <!-- Author Section -->
    <section class="author__section__wrapper" id="author">
        <div class="rlms-container">
            <div class="group__box">
                <div class="author__description__wrapper">
                    <h3 class="title">Dr. Barbara E. Esch</h3>
                    <h6 class="short__title">Ph.D., BCBA-D, CCC - SLP</h6>
                    <div class="short__description__wrapper">
                        <p> A behavior analyst and speech pathologist with extensive experience in behavioral
                            interventions for
                            children and adults, Dr. Esch received her Ph.D. in Applied Behavior Analysis from Western
                            Michigan
                            University under the direction of Dr. Jack Michael and Dr. Jim Carr and her M.A. in Speech
                            Pathology from
                            Michigan State University. </p>
                        <br />
                        <p> She has published research on behavioral treatments for early speech acquisition and aphasia
                            assessment
                            in The Analysis of Verbal Behavior, the Journal of Applied Behavior Analysis, and the
                            Journal of Autism
                            and Developmental Disabilities. She has presented workshops, training symposia, and research
                            in the United
                            States, Canada, Europe, and Australia, focusing on the use of behavioral procedures to
                            improve speech and
                            language skills for individuals of all ages with a wide range of diagnoses. </p>
                    </div>
                    <div class="start__journey__btn">
                        <RouterLink :to="registerUrl">Start Journey</RouterLink>
                    </div>
                </div>
                <div class="author__img__wrapper">
                    <img :src="authorImg" alt="Author" />
                </div>
            </div>
        </div>
    </section>

    <!-- About Us -->
    <section class="about__us__wrapper" :style="{ backgroundImage: `url(${aboutusBg})` }" id="about">
        <div class="rlms-container">
            <div class="group__box">
                <div class="img__wrapper">
                    <img :src="aboutusImg" alt="about us" />
                </div>
                <div class="about__description__wrapper">
                    <h3 class="title">About EESAPP App</h3>
                    <div class="about__desc">
                        <p> Early Echoic Skills Assessment and Program Planner App (EESAPP App) Most humans learn to
                            speak quite
                            easily, with no special training. For those who do not, the task falls to others, who may
                            find it beyond
                            daunting to figure out where to start. But, in fact, there is no reason that we should
                            expect ourselves to
                            know how to do this. Speech teaching and jump-starting early vocalizations are not
                            intuitive. The Early
                            Echoic Skills Assessment and Program Planner (EESAPP) is aimed at making this process a
                            little easier. The
                            EESAPP App records your learner’s echoics and automates some of the program planning for
                            those
                            professionals who are not trained as speech-language pathologists. </p>
                    </div>
                    <div class="start__journey__btn">
                        <RouterLink :to="registerUrl">Start Journey</RouterLink>
                    </div>
                    <div class="btn__tag__arrow">
                        <img :src="btnTagArrowImg" />
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Features -->
    <section class="features__section__wrapper">
        <div class="rlms-container">
            <div class="features__cover__wrapper">
                <h2 class="title">Best Features of EESAPP App</h2>

                <div class="features__list__box">
                    <div class="feature__card__item" v-for="feature in features" :key="feature.title">
                        <div class="feature__icon">
                            <img :src="feature.icon" :alt="feature.title" />
                        </div>
                        <div class="feature__description__wrapper">
                            <h5 class="title">{{ feature.title }}</h5>
                            <div class="feature__shortnote">
                                <p>{{ feature.description }}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="features__btn__box">
                    <div class="signup__btn">
                        <RouterLink :to="registerUrl">Start Journey</RouterLink>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Download Section -->
    <section class="download__app__section" :style="{ backgroundImage: `url(${aboutusBg})` }">
        <div class="rlms-container">
            <div class="group__box">
                <div class="app__description__wrapper">
                    <h3 class="title">Use the EESAPP App on any internet-connected device</h3>
                    <div class="short__description">
                        <p>
                            The app can be used on any PC, laptop, tablet, or phone. Your
                            information is always secure and encrypted
                        </p>
                    </div>
                    <!-- Play store links -->
                    <div class="btn__group__wrapper" v-if="false">
                        <div class="app__store__btn">
                            <a :href="appStoreLink" target="_blank">
                                <span class="btn__icon">
                                    <img :src="appStoreIcon" alt="App Store" />
                                </span>
                                <span class="btn__text">App Store</span>
                            </a>
                        </div>

                        <div class="app__store__btn">
                            <a :href="playStoreLink" target="_blank">
                                <span class="btn__icon">
                                    <img :src="playStoreIcon" alt="Play Store" />
                                </span>
                                <span class="btn__text">Play Store</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="app__img__wrapper">
                    <img :src="eesaFrames" alt="EESA Frames" />
                </div>
            </div>
        </div>
    </section>

    <!-- Video Section -->
    <section class="video__section__wrapper">
        <div class="rlms-container">
            <div class="section__title__box">
                <h3 class="title">See How It Works</h3>
                <div class="start__journey__btn">
                    <RouterLink :to="registerUrl">Start Journey</RouterLink>
                </div>
            </div>

            <div class="video__box__wrapper">
                <img :src="videoThumbnail" alt="Video thumbnail" />
                <div class="videoplay__btn">
                    <a class="popup-youtube" :href="workVideoUrl">
                        <img :src="videoPlayIcon" alt="Play video" />
                    </a>
                </div>
            </div>
        </div>
    </section>

    <!-- Achievements Section -->
    <section class="achievements__section__wrapper" v-if="false">
        <div class="rlms-container">
            <h3 class="title">Achievements Of EESAPP App</h3>
            <div class="achievements__list__box">
                <div class="achievements__item" v-for="(achievement, index) in achievements" :key="index">
                    <div class="icon__box">
                        <img :src="achievement.icon" :alt="achievement.info" />
                    </div>
                    <div class="text__wrap">
                        <h4 class="title">{{ achievement.value }}</h4>
                        <span class="info">{{ achievement.info }}</span>
                    </div>
                </div>
            </div>
        </div>
    </section>


    <section class="powered__by__dmtd__section">
        <div class="rlms-container">
            <div class="group__box__wrapper">
                <div class="content__box__wrapper">
                    <label class="pb__label">Powered By:</label>
                    <h3 class="title">DataMakesTheDifference</h3>
                    <div class="short__description">
                        <p>
                            To learn about our mission and our team
                            <a href="https://datamakesthedifference.com/" target="_blank" rel="noopener">click here</a>
                        </p>
                    </div>
                    <div class="start__journey__btn">
                        <RouterLink :to="registerUrl">Start Journey</RouterLink>
                    </div>
                    <div class="btn__tag__arrow">
                        <img :src="btnTagArrowImg" alt="Arrow" />
                    </div>
                </div>

                <div class="powered__by__companies__Box">
                    <div class="company__box__wrapper" v-for="(company, index) in companies.slice(0, 3)" :key="index">
                        <a :href="company.link" target="_blank" rel="noopener">
                            <img :src="(company._img) ?? company.img" alt="Company Logo" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- FAQ Section -->
    <section class="faq__section__wrapper" :style="{ backgroundImage: `url(${aboutusBg})` }">
        <div class="rlms-container">
            <h3 class="title">Frequently Asked Questions</h3>
            <div class="faq__box__wrapper">
                <div class="faq-container">
                    <div class="faq__item__box" v-for="(faq, index) in faqs" :key="index">
                        <div class="faq-item" @click="toggleFaq(index)">
                            <div class="faq-question">{{ faq.question }}</div>
                            <div class="icon-container">
                                <i class="faq__icon" :style="{
                                    backgroundImage: faq.open
                                        ? `url('${faqOpenIcon}')`
                                        : `url('${faqCloseIcon}')`,
                                }"></i>
                            </div>
                        </div>
                        <div :class="`faq-answer ${faq.open ? 'active' : ''}`" v-if="faq.open" v-html="faq.answer">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script setup>
import { reactive, ref, onMounted } from 'vue';
import { RouterLink } from 'vue-router';
import $ from 'jquery';
import 'magnific-popup';
import 'magnific-popup/dist/magnific-popup.css';

import heroBg from '@/assets/images/hero-section-bg.png';
import heroImg from '@/assets/images/hero-img.png';
import playCircleIcon from '@/assets/images/play-circle-icon.svg';
import heroArrowImg from '@/assets/images/hero-arrow-img.svg';
import ouCompaniesBg from '@/assets/images/our-companies-bg.png';
import vbMappImg from '@/assets/images/vb-mappapp-img.png'
import vbMappImg2 from '@/assets/images/company-img1.png'
import bcbaNowImg from '@/assets/images/bcba-now-img.png'
import bcbaNowImg2 from '@/assets/images/company-img2.png'
import esseImg from '@/assets/images/esse-img.png'
import esseImg2 from '@/assets/images/company-img3.png'
import dmtdImg from '@/assets/images/dmtd-img.png'
import drImg from '@/assets/images/dr-img.png'
import authorImg from '@/assets/images/author-img.png';
import aboutusBg from '@/assets/images/about-us-bg.png';
import aboutusImg from '@/assets/images/about-img.png';
import btnTagArrowImg from '@/assets/images/btn-tag-arrow.png';
import featureIcon1 from '@/assets/images/feature-icon1.svg';
import featureIcon2 from '@/assets/images/feature-icon2.svg';
import featureIcon3 from '@/assets/images/feature-icon3.svg';
import featureIcon4 from '@/assets/images/feature-icon4.svg';
import featureIcon5 from '@/assets/images/feature-icon5.svg';
import featureIcon6 from '@/assets/images/feature-icon6.svg';
import eesaFrames from '@/assets/images/eesaframes.png';
import appStoreIcon from '@/assets/images/app-store-ios.png';
import playStoreIcon from '@/assets/images/playstore-icon.png';
import videoPlayIcon from '@/assets/images/video-play-button.svg';
import videoThumbnail from '@/assets/images/video-thumbnail-img.png';
import faqOpenIcon from '@/assets/images/faq-open-icon.svg';
import faqCloseIcon from '@/assets/images/faq-close-icon.svg';
import achievementsIcon1 from '@/assets/images/achievements-icon1.svg';
import achievementsIcon2 from '@/assets/images/achievements-icon2.svg';
import achievementsIcon3 from '@/assets/images/achievements-icon3.svg';
import achievementsIcon4 from '@/assets/images/achievements-icon4.svg';

const registerUrl = '/register'
const socialWorkLink = 'https://www.youtube.com/watch?v=-Soi2TgZvxQ'
const workVideoUrl = 'https://www.youtube.com/watch?v=-Soi2TgZvxQ'

// Our Companies section
const companies = [
    {
        link: 'https://datamakesthedifference.com/vb-mapp-app',
        img: vbMappImg,
        _img: vbMappImg2
    },
    {
        link: 'https://datamakesthedifference.com/bcba-now',
        img: bcbaNowImg,
        _img: bcbaNowImg2
    },
    {
        link: 'https://datamakesthedifference.com/efl-app',
        img: esseImg,
        _img: esseImg2
    },
    {
        link: 'https://datamakesthedifference.com/',
        img: dmtdImg
    },
    {
        link: '#',
        img: drImg
    }
];

// Feature secction
const features = [
    {
        title: 'assessments',
        icon: featureIcon1,
        description:
            'Run an unlimited number of assessments per year per learner. The app offers users the ability to record the learner’s responses, select correct and incorrect syllables in the response, and/or transcribe each response. The app will offer users.',
    },
    {
        title: 'program planning',
        icon: featureIcon2,
        description:
            "Create personalized, data-driven learning plans tailored to each learner's needs.",
    },
    {
        title: 'voice bank',
        icon: featureIcon3,
        description:
            "Store all of your learner’s recorded responses in an individual voice bank to compare over time.",
    },
    {
        title: 'flexible payment',
        icon: featureIcon4,
        description: 'Volume purchasing discounts.',
    },
    {
        title: 'team collaboration',
        icon: featureIcon5,
        description:
            'Each team member can set up a free account and be given access to a learner’s dashboard.',
    },
    {
        title: 'responsive support desk',
        icon: featureIcon6,
        description: 'Easy access to support from DataMTD.',
    },
];

// Achievements section
const achievements = ref([
    {
        icon: achievementsIcon1,
        value: '10K+',
        info: 'Happy Learners'
    },
    {
        icon: achievementsIcon2,
        value: '100%',
        info: 'Learner Growth'
    },
    {
        icon: achievementsIcon3,
        value: '11K+',
        info: 'Sign Up Every Year'
    },
    {
        icon: achievementsIcon4,
        value: '80+',
        info: 'Course in EESA'
    }
]);

// Download Section
const appStoreLink = 'https://your-appstore-link-here';
const playStoreLink = 'https://your-playstore-link-here';

const toggleFaq = (index) => {
    faqs[index].open = !faqs[index].open
}

const faqs = reactive([
    {
        question: 'What is the EESAPP?',
        answer:
            '<p>The Early Echoic Skills Assessment and Program Planner (EESAPP) is a specialized tool designed to assess and improve early vocal imitation, or “echoic” skills, primarily for individuals with autism or developmental disabilities. It provides structured assessments and program planning to help develop speech skills effectively.</p>',
        open: false,
    },
    {
        question: 'What does the EESAPP App offer?',
        answer:
            `<p>The app version of the EESAPP brings a host of features to enhance the assessment and intervention process. These include:</p>
      <ul>
          <li>Audio Recording and Annotation.</li>
          <li>Easily record audio of learners' echoic attempts and annotate vowels, consonants, or specific phonemes for detailed analysis.</li>
          <li>Auto-Generated Work Packets.</li>
          <li>After completing an assessment, the app generates a comprehensive work packet tailored to the learner’s specific needs, saving time and ensuring accuracy.</li>
          <li>Track Echoic Skills Progress.</li>
          <li>Keep track of each learner’s progress over time. The app provides visual reports and insights into skill development, helping you adjust your intervention plan as needed.</li>
          <li>Centralized Learner Management.</li>
          <li>Store and organize all your learners' data in one secure location, making it easy to monitor progress and revisit previous assessments.</li>
          <li>User-Friendly Interface.</li>
          <li>Designed for ease of use, the app allows professionals to conduct assessments, analyze results, and implement programs efficiently, all from their device.</li>
      </ul>`,
        open: false,
    },
    {
        question: 'How is the app different from the traditional EESAPP?',
        answer:
            '<p>While the traditional EESAPP focuses on manual assessments and planning, the app version automates much of the process, making it faster and more efficient. With features like audio recording, real-time progress tracking, and automatically generated work packets, the app enhances the overall user experience and enables more precise interventions.</p>',
        open: false,
    },
    {
        question: 'Who is the EESAPP App for?',
        answer:
            '<p>The app is designed for behavior analysts, speech-language pathologists, educators, and other professionals working to develop speech skills in early learners. Its features are also valuable for parents seeking to actively support their child’s vocal development.</p>',
        open: false,
    },
    {
        question: 'Can I use the app for multiple learners?',
        answer:
            '<p>Yes, the app supports multiple learners and allows you to manage their profiles, track progress, and generate individualized work packets for each learner.</p>',
        open: false,
    },
    {
        question: 'Is the data secure?',
        answer:
            '<p>Absolutely. The app ensures that all data is securely stored and accessible only to authorized users, maintaining confidentiality and compliance with data protection standards.</p>',
        open: false,
    },
]);


onMounted(() => {
    $('.popup-youtube').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });
});
</script>